<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #QuinielaAdmin
    v-layout(align-start='' justify-start='' row='' fill-height='')
      v-flex(xs12 md12 sm12)
        v-card(style="border-radius:5px;background-color: white;")
          v-card-title(style='padding: 8px !important;').justify-center
            img(src='../assets/logo.png' style='height: auto;width: 80px;border-radius:5px')
        v-card(style="border-radius:5px;background-color: black")
          v-card-title(style="padding: 7px;").justify-center
            span.white--text Administración Quiniela
    v-layout(align-start='' justify-start='' row='' wrap='' fill-height='')
      v-flex(xs12 style='margin-top:10px;')
        v-tabs(v-model='tab' color='#fe0100' dark='' background-color='black')
          v-tab Configuración
          v-tab Tabla de Posiciones
          v-tab Apuestas
          v-tabs-items(v-model='tab')
            //─── Tab Configuración ───────────────────────────────────────────
            v-tab-item
              v-card(flat='' style='padding:16px;')
                v-form(ref='formConfig')
                  v-layout(wrap='')
                    v-flex(xs12 sm6 style='padding-right:8px;')
                      v-text-field(v-model='config.mundial' label='Nombre del Mundial' outlined='' dense='')
                    v-flex(xs12 sm6 style='display:flex;align-items:center;')
                      v-switch(v-model='config.activo' label='Quiniela activa' color='green')
                    v-flex(xs12 sm3 style='padding-right:8px;')
                      v-text-field(v-model.number='config.pts_resultado_exacto' label='Pts Resultado Exacto' type='number' outlined='' dense='')
                    v-flex(xs12 sm3 style='padding-right:8px;')
                      v-text-field(v-model.number='config.pts_diferencia_correcta' label='Pts Diferencia Correcta' type='number' outlined='' dense='')
                    v-flex(xs12 sm3 style='padding-right:8px;')
                      v-text-field(v-model.number='config.pts_ganador_correcto' label='Pts Ganador Correcto' type='number' outlined='' dense='')
                    v-flex(xs12 sm3)
                      v-text-field(v-model.number='config.pts_bonus_eliminatoria' label='Pts Bonus Eliminatoria' type='number' outlined='' dense='')
                    v-flex(xs12 sm6 style='padding-right:8px;')
                      v-text-field(v-model='config.fecha_inicio' label='Fecha Inicio (YYYY-MM-DD)' outlined='' dense='')
                    v-flex(xs12 sm6)
                      v-text-field(v-model='config.fecha_fin' label='Fecha Fin (YYYY-MM-DD)' outlined='' dense='')
                    v-flex(xs12 style='display:flex;justify-content:flex-end;margin-top:8px;')
                      v-btn(color='#fe0100' dark='' @click='guardarConfig' :loading='loading') Guardar Configuración

            //─── Tab Tabla ───────────────────────────────────────────────────
            v-tab-item
              v-card(flat='' style='padding:16px;')
                v-layout(wrap='')
                  v-flex(xs12 style='display:flex;justify-content:flex-end;margin-bottom:8px;')
                    v-btn(color='black' dark='' small='' @click='loadTabla')
                      v-icon(left='') refresh
                      | Actualizar
                  v-flex(xs12)
                    v-data-table.elevation-1(:headers='headersTabla' :items='tabla')
                      template(slot='items' slot-scope='props')
                        td {{ props.index + 1 }}
                        td {{ props.item.cliente || props.item._id }}
                        td(style='font-weight:bold;color:#fe0100;font-size:16px;') {{ props.item.puntos }}
                        td {{ props.item.apuestas }}
                        td {{ props.item.tickets_usados }}

            //─── Tab Apuestas ────────────────────────────────────────────────
            v-tab-item
              v-card(flat='' style='padding:16px;')
                v-layout(wrap='')
                  v-flex(xs12 sm5 style='padding-right:8px;')
                    v-select(v-model='filtroPartido' :items='partidosSelect' item-text='label' item-value='_id' label='Filtrar por partido' outlined='' dense='' clearable='' @change='loadApuestas')
                  v-flex(xs12)
                    v-data-table.elevation-1(:headers='headersApuestas' :items='apuestas')
                      template(slot='items' slot-scope='props')
                        td {{ props.item.fecha_apuesta | moment('DD/MM/YYYY HH:mm') }}
                        td {{ props.item.cliente || props.item.co_cli }}
                        td
                          span(v-if='props.item.partido_id')
                            | {{ props.item.partido_id.nombre_local || props.item.partido_id.equipo_local }}
                            |  vs 
                            | {{ props.item.partido_id.nombre_visitante || props.item.partido_id.equipo_visitante }}
                        td {{ props.item.pronostico.goles_local }} - {{ props.item.pronostico.goles_visitante }}
                        td {{ props.item.tickets.join(', ') }}
                        td
                          span(v-if='props.item.puntos_total !== null' style='font-weight:bold;color:green;') {{ props.item.puntos_total }}
                          span(v-else) —
</template>

<script>
import Api from '@/services/methods'
export default {
  name: 'QuinielaAdmin',
  data: () => ({
    tab: 0,
    loading: false,
    config: {
      mundial: 'Mundial 2026',
      activo: false,
      pts_resultado_exacto: 3,
      pts_diferencia_correcta: 2,
      pts_ganador_correcto: 1,
      pts_bonus_eliminatoria: 1,
      fecha_inicio: '',
      fecha_fin: ''
    },
    tabla: [],
    apuestas: [],
    partidos: [],
    filtroPartido: null,
    headersTabla: [
      { text: '#', sortable: false },
      { text: 'Cliente', value: 'cliente' },
      { text: 'Puntos', value: 'puntos' },
      { text: 'Apuestas', value: 'apuestas' },
      { text: 'Tickets usados', value: 'tickets_usados' }
    ],
    headersApuestas: [
      { text: 'Fecha', value: 'fecha_apuesta' },
      { text: 'Cliente', sortable: false },
      { text: 'Partido', sortable: false },
      { text: 'Pronóstico', sortable: false },
      { text: 'Tickets', sortable: false },
      { text: 'Puntos totales', value: 'puntos_total' }
    ]
  }),
  computed: {
    partidosSelect () {
      return this.partidos.map(p => ({
        _id: p._id,
        label: `${p.nombre_local || p.equipo_local} vs ${p.nombre_visitante || p.equipo_visitante} (${p.fase})`
      }))
    }
  },
  created () {
    this.loadConfig()
    this.loadTabla()
    this.loadApuestas()
    Api.get('quiniela/partidos').then(res => { this.partidos = res.data || [] })
  },
  methods: {
    loadConfig () {
      Api.get('quiniela/config').then(res => {
        if (res.data) {
          this.config = Object.assign({}, this.config, res.data)
          if (this.config.fecha_inicio) this.config.fecha_inicio = this.config.fecha_inicio.substring(0, 10)
          if (this.config.fecha_fin) this.config.fecha_fin = this.config.fecha_fin.substring(0, 10)
        }
      })
    },
    guardarConfig () {
      this.loading = true
      Api.post('quiniela/config', this.config).then(() => {
        this.$swal('Listo', 'Configuración guardada', 'success')
      }).catch(e => {
        this.$swal('Error', (e.response && e.response.data && e.response.data.message) || 'Error al guardar', 'error')
      }).finally(() => { this.loading = false })
    },
    loadTabla () {
      Api.get('quiniela/tabla').then(res => { this.tabla = res.data || [] })
    },
    loadApuestas () {
      const url = this.filtroPartido
        ? `quiniela/apuestas/partido/${this.filtroPartido}`
        : 'quiniela/apuestas'
      Api.get(url).then(res => { this.apuestas = res.data || [] })
    }
  }
}
</script>
